<script setup lang="ts">
import { computed, PropType } from 'vue';
import {
   NotificationBackground,
   NotificationIcon,
   Notification as NotificationInterface,
   NotificationType,
} from '../../interfaces/notification.interface';

const props = defineProps({
   notificationItem: {
      type: Object as PropType<NotificationInterface>,
      default: () => [],
   },
});
NotificationType;

const notification_background = computed(() => NotificationBackground[props.notificationItem?.type ?? 'Info']);
const notification_icon = computed(() => NotificationIcon[props.notificationItem?.type ?? 'Info']);
</script>

<template>
   <div class="notification">
      <div class="notification__sidebar"></div>
      <div class="notification__message">
         <i :class="['notification__message__icon', 'fas', notification_icon]" />
         <span> {{ notificationItem.message }}</span>
      </div>
   </div>
</template>

<style lang="scss" scoped>
.notification {
   display: flex;
   flex-direction: row;
   align-items: center;

   height: 35px;

   border-radius: var(--nxt-radius) 0 0 var(--nxt-radius);
   background-color: var(--nxt-white);
}

.notification__sidebar {
   height: 100%;
   width: var(--nxt-gutter-large);
   border-radius: var(--nxt-radius) 0 0 var(--nxt-radius);
   background-color: v-bind(notification_background);
}

.notification__message {
   padding: var(--nxt-gutter);

   &__icon {
      margin-right: var(--nxt-gutter);
   }
}
</style>
